import { Metamodel } from '../base/model';
import { irTypesConst } from '../../integrationruntime/integrationruntime.constants';
import { ManagedIntegrationRuntime } from './managed.integrationRuntime';

@Metamodel.model({
    name: irTypesConst.SSIS
})
export class ManagedLinkedIntegrationRuntime extends ManagedIntegrationRuntime {
    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
